'use strict';

var updateHeader = status => {
    var $headerNav = $('.header-nav');
    var $headerPromo = $('.header-banner');
    var $page = $('.page');

    if (status === 'fixed') {
        $headerNav.addClass('fixed');
        $headerPromo.addClass('fixed');

    } else {
        $headerNav.removeClass('fixed');
        $headerPromo.removeClass('fixed');
    }
}

module.exports = function() {

    // Fix/unfix header to top of screen, dependent on class added by custom preference
    // Note: This is intentionally not using utilities/scroll.js so that it can fix immediately vs. being debounced. Should be replaced with CSS position:sticky once IE11 support is dropped.
    var hasFixedEnhancedHeader = $('header').hasClass('fixed-header-enhanced');
    var hasFixedHeader = $('header').hasClass('fixed-header');
    $(window).scroll(event => {
        if (hasFixedHeader) {
            var $headerBanner = $('.header-banner');
            var headerBannerHeight = $headerBanner.length ? $headerBanner.outerHeight() : 0;
            var scrollTop = $(event.target).scrollTop();

            if (scrollTop > headerBannerHeight) {
                updateHeader('fixed');
            } else {
                updateHeader('unfixed');
            }
        }

        if (hasFixedEnhancedHeader) {
            var $headerBanner = $('.header-banner');
            var $headerNav = $('.header-nav');
            var headerBannerHeight = $headerBanner.length ? $headerBanner.outerHeight() : 0;
            var headerNavHeight = $headerNav.length ? $headerNav.outerHeight() : 0;

            var scrollTop = $(event.target).scrollTop();
            // scroll a few pixels before animating on mobile (visual glithes appear if scroll-down class hasn't been added yet)
            var isMobile = window.isMobile();
            var target = isMobile ? 10 : headerNavHeight; 
            
            if (scrollTop > (target)) {
                updateHeader('fixed');
            } else {
                updateHeader('unfixed');
            }
        }
    });

    var isMobile = window.isMobile();
    if ($('header').hasClass('transparent-header') && !isMobile) {
        $('.header-nav').hover(
            function() {
                $(this).removeClass('transparent-nav');
            }, function() {
                $(this).addClass('transparent-nav');
            }
        );
    }

    // Check for presence of content assets in MegaMenu
    var $megamenuDropdown = $('.megamenu > .dropdown-menu');

    $megamenuDropdown.each((index, element) => {
        var $megamenu = $(element);
        if ($megamenu.find('.megamenu-asset-1').children().length) {
            $megamenu.addClass('has-asset-1');
        }
        if ($megamenu.find('.megamenu-asset-2').children().length) {
            $megamenu.addClass('has-asset-2');
        }
    });

    // Show/hide content assets on mobile based on category level
    if (isMobile) {
        var $thirdMenuBackBtn = $('.megamenu .menu-subcategories > .dropdown-item'),
            $thirdSubLink = $('.megamenu .menu-subcategories > .dropdown-item > .dropdown-link');

        $thirdSubLink.on('click', function () {
            $('.megamenu.show .menu-subcategories').parent('li').addClass('thirdCatOpen');
        });
        $thirdMenuBackBtn.on('click', function () {
            $('.megamenu.show .menu-subcategories').parent('li').removeClass('thirdCatOpen');
        });
    }

    $('.main-menu .navbar-nav').on('mouseenter mouseleave', function () {
        $(this).toggleClass('nav-item-hover');
    });

    $('.menu-level-1 .nav-item').on('mouseenter', function () {
        //$('.modal-background').show();
        $('.custom-select').blur();
    });

    $('.menu-level-1 .nav-item').on('mouseleave', function () {
        $('.modal-background').hide();
    });



    $('header .site-search').on('mouseenter', event => {
        var $siteSearch = $(event.target).closest('.site-search');
        $siteSearch.addClass('expanded');
    });

    $('header .site-search').on('mouseleave', event => {
        var $siteSearch = $(event.target).closest('.site-search');
        var $input = $siteSearch.find('input');
        // Only collapse if the user isn't typing and hasn't entered text
        if (!$input.is(':focus') && !$input.val()) {
            $siteSearch.removeClass('expanded');
        }
    });

    $('form[name=simpleSearch]').on('submit', event => {
        var $form = $(event.target);
        var $input = $('input[name=q]',$form);
        //keep search from submitting if query is empty
        if ($input.val() == "") {
            $input.focus();
            event.preventDefault();
        }
    });

};
